import * as Sentry from '@sentry/react';
import { compose } from 'redux';
import { App as AppComponent } from './App';
import { withContainer } from './withContainer';
import { ScrollContext } from './withScrollRestore';

const App = compose(
  Sentry.withProfiler,
  withContainer,
)(AppComponent);

export {
  App,
  AppComponent,
  ScrollContext,
};
export * from './withContainer';
